import script from "./DeviceTypeDetail.vue?vue&type=script&setup=true&name=DeviceTypeDetail&lang=js"
export * from "./DeviceTypeDetail.vue?vue&type=script&setup=true&name=DeviceTypeDetail&lang=js"

import "./DeviceTypeDetail.vue?vue&type=style&index=0&id=49c9d918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c9d918"]])

export default __exports__